import React from 'react';
import Header from '../../../components/layout/headers/Header'
import DynamicNavigation from "../../../components/layout/navigation/DynamicNavigation"
import CreateNewPolicyPage from "./create/CreateNewPolicyPage"

const ApplyPolicy = () => {

    return (
        <>
            <Header />
            <DynamicNavigation />
            <div className="content-body">
                <div className="container mx-auto">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12">
                            <CreateNewPolicyPage  className="mt-2 m-auto" existingApplicationProgress={{applicationDetail:null}} isLifePolicy={true} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

};

export default ApplyPolicy;